export interface SortOption {
  label: string;
  value: string;
}

export const availibleFilters = [
  { name: 'Tomadas', code: 'taken' },
  { name: 'Recomendadas', code: 'suggested' },
  { name: 'Nivel Básico', code: 'basicLevel' },
  { name: 'Nivel Intermedio', code: 'mediumLevel' },
  { name: 'Nivel Avanzado', code: 'advancedLevel' },
];

export enum OptionValue {
  Newest = 'newest',
  Oldest = 'oldest',
  Alphabetical = 'alphabetical',
  ReverseAlphabetical = 'reverseAlphabetical',
}

export const sortOptions: SortOption[] = [
  { label: 'Más reciente', value: OptionValue.Newest },
  { label: 'Más antiguo', value: OptionValue.Oldest },
  { label: 'A-Z', value: OptionValue.Alphabetical },
  { label: 'Z-A', value: OptionValue.ReverseAlphabetical },
];

export const sortTypes = [
  { name: 'Recientes', code: 'newest', sort: { createdDate: -1 } },
  { name: 'Antiguas', code: 'oldest', sort: { createdDate: 1 } },
  { name: 'Populares', code: 'popular', sort: { takenCount: -1 } },
];

export interface ICustomFilter {
  name: string;
  type: 'string' | 'number' | 'boolean' | 'date' | 'select';
  options?: any[];
}

export interface FiltersConfig {
  page?: number;
  rowsPerPage?: number;
  sort?: { [key: string]: number };
  filters?: { [key: string]: any };
  text?: string;
  returnProps?: Record<string, 0 | 1>;
}

export interface IFilterQueryResponse<T> {
  rows: T[];
  count: number;
  skip: number;
}

export interface ListFilterBarOptions {
  showCreateButton?: boolean;
  showViewButton?: boolean;
  showActions?: boolean;
  // Add other UI behavior flags here, e.g.:
  // showSortOptions?: boolean;
  // showFilterButton?: boolean;
  // allowManualSearch?: boolean;
}
